import React, { useState } from "react";
import { useLogin, Notification, useNotify } from "react-admin";
import { Button, TextField, Typography, Box, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    color: "#fff",
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255, 255, 255, 0.7)",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#fff",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "rgba(255, 255, 255, 0.5)",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
    },
  },
}));

const Login = () => {
  const login = useLogin();
  const notify = useNotify();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const submit = (e) => {
    e.preventDefault();
    login({ username, password }).catch((error) => {
      notify("Usuario o contraseña incorrectos", { type: "error" });
    });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          background: "rgb(243, 232, 255)",
        }}
      >
        <Paper
          elevation={12}
          sx={{
            padding: { xs: 3, sm: 4 },
            width: "100%",
            maxWidth: "420px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "12px",
            background: "rgb(88, 28, 135)",
            color: "#fff",
          }}
        >
          <Box
            component="img"
            src="/logo-winco.png"
            alt="Winco Logo"
            sx={{
              width: "180px",
              mb: 3,
            }}
          />
          <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
            Panel de Administración
          </Typography>
          <Box
            component="form"
            onSubmit={submit}
            noValidate
            sx={{ width: "100%" }}
          >
            <StyledTextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Usuario"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <StyledTextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                py: 1.5,
                fontSize: "1rem",
                backgroundColor: "rgb(243, 232, 255)",
                color: "rgb(88, 28, 135)",
                "&:hover": {
                  backgroundColor: "#fff",
                },
              }}
            >
              Iniciar Sesión
            </Button>
          </Box>
        </Paper>
      </Box>
      <Notification />
    </>
  );
};

export default Login;
